import { IInfo } from 'reactApp/components/SharingNew/SharingNew.types';

export interface IProps {
    info: IInfo;
    onClose: () => void;
    onUnmount: (action: EAction) => void;
}

export enum EAction {
    REMOVE = 'remove',
    UNMOUNT = 'unmount',
}
